const compact = new Intl.NumberFormat("es-EC", { notation: "compact", maximumFractionDigits: 1 });
const integer = new Intl.NumberFormat("es-EC", { maximumFractionDigits: 0 });

export function formatMoney(value) {
    const number = Number(value || 0);
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: number < 0.01 && number > 0 ? 5 : 2 }).format(number);
}

export function formatCompact(value) {
    const number = Number(value || 0);
    if (Math.abs(number) < 1000) return integer.format(number);
    return compact.format(number);
}

export function formatNumber(value) {
    return integer.format(Number(value || 0));
}

export function formatDuration(ms) {
    const value = Number(ms || 0);
    if (value < 1000) return `${Math.round(value)} ms`;
    return `${(value / 1000).toFixed(2)} s`;
}

export function formatDateTime(value) {
    if (!value) return "—";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "—";
    return new Intl.DateTimeFormat("es-EC", { dateStyle: "short", timeStyle: "medium" }).format(date);
}

export function statusText(status) {
    const labels = {
        success: "OK",
        in_progress: "En curso",
        provider_error: "Error proveedor",
        timeout: "Timeout",
        gateway_error: "Error gateway",
        active: "Activo",
        disabled: "Deshabilitado",
        revoked: "Revocada",
    };
    return labels[status] || status || "—";
}
